import { Column } from '../../types';

export const Columns: Column[] = [
  { name: 'TITLE', key: 'title', width: 300, align: 'start' },
  { name: 'CITY', key: 'city', width: 200, align: 'start' },
  { name: 'ADDRESS', key: 'address', width: 300, align: 'start' },
  { name: 'TYPE', key: 'type', width: 50, align: 'start' },
  { name: 'ACTIONS', key: 'actions', width: 100, align: 'center' },
];
